/**
 * 製品サブグループ規格図マスタ エンティティ
 */
import { isNud } from '@/utilities/typing';
import ProductSubgroup from '@/models/entities/product-subgroup';

class ProductSubgroupStandardDrawing {
    product_subgroup_standard_drawing_id;
    product_subgroup;
    file_label;
    file_name;
    file_path;
    thumbnail_path;
    mime_type;
    file_size;
    file_url;
    thumbnail_url;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.product_subgroup_standard_drawing_id = properties.product_subgroup_standard_drawing_id ?? null;
        this.product_subgroup = new ProductSubgroup(properties.product_subgroup);
        this.file_label = properties.file_label;
        this.file_name = properties.file_name;
        this.file_path = properties.file_path;
        this.thumbnail_path = properties.thumbnail_path;
        this.mime_type = properties.mime_type;
        this.file_size = properties.file_size;
        this.file_url = properties.file_url;
        this.thumbnail_url = properties.thumbnail_url;
    }
}

export default ProductSubgroupStandardDrawing;
